var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnScene(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21C13.7615 21 16.2615 19.8807 18.0711 18.0711C19.8807 16.2615 21 13.7615 21 11C21 8.2386 19.8807 5.7386 18.0711 3.92894C16.2615 2.11929 13.7615 1 11 1C8.2386 1 5.7386 2.11929 3.92894 3.92894C2.11929 5.7386 1 8.2386 1 11C1 13.7615 2.11929 16.2615 3.92894 18.0711C5.7386 19.8807 8.2386 21 11 21Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9494 6.05025C14.6826 4.7835 12.9326 4 10.9996 4C9.06655 4 7.31655 4.7835 6.0498 6.05025",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnScene);
export default __webpack_public_path__ + "static/media/icn-scene.eaee8cab1368a3885c39582e539f2fe9.svg";
export { ForwardRef as ReactComponent };